import { render, staticRenderFns } from "./fromUnitInsuredNew.vue?vue&type=template&id=131dfb1a&scoped=true&"
import script from "./fromUnitInsuredNew.vue?vue&type=script&lang=js&"
export * from "./fromUnitInsuredNew.vue?vue&type=script&lang=js&"
import style0 from "./fromUnitInsuredNew.vue?vue&type=style&index=0&id=131dfb1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131dfb1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('131dfb1a')) {
      api.createRecord('131dfb1a', component.options)
    } else {
      api.reload('131dfb1a', component.options)
    }
    module.hot.accept("./fromUnitInsuredNew.vue?vue&type=template&id=131dfb1a&scoped=true&", function () {
      api.rerender('131dfb1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insuranceCenter/components/fromUnitInsuredNew.vue"
export default component.exports